import { Navigate } from "react-router";
import { useAppSelector } from "../redux/store";

interface RequirePermissionProps {
  permission: string;
  children: React.ReactNode;
}

/**
 * Route guard for permission-gated pages (the same `permissions` map the Users
 * screen manages). Super-admins bypass the check, mirroring the API.
 */
export default function RequirePermission({
  permission,
  children,
}: RequirePermissionProps) {
  const { user } = useAppSelector((state) => state.login);

  const allowed =
    !!user && (user.role === "super-admin" || !!user.permissions?.[permission]);

  if (!allowed) {
    const fallback =
      user?.role === "client" || user?.role === "employee"
        ? "/project-home"
        : "/login";
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
